import { cn, createBEM } from "@/libs";
import "./index.scss";
export const Current = ({
  value,
  data
}: {
  value: string;
  data: any;
}) => {
  const b = createBEM('i-formcurrent');
  return <div className={cn(b())} data-sentry-component="Current" data-sentry-source-file="index.tsx">
    {data.marketType === '2' ? "应得" : "应付"}: <span className={cn(b('text'))}>{value || '0'} {data.paymentType || ''}</span>
  </div>;
};